export default "__VITE_ASSET__DKIcXjyI__"